import { useTheme } from '@mui/material';

import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `DeFi development services with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What is decentralized finance?',
      description: `A:
        Decentralized finance (DeFi), refers to a blockchain-based financial system that operates without traditional intermediaries like banks or brokerages. Instead, it leverages smart contracts and decentralized applications (dApps) built on blockchain platforms like Ethereum to provide financial services such as lending, borrowing, trading, and asset management.
        <br />
        <br />
        Key features of decentralized finance are:
        <ul>
          <li>
            <b>Decentralization: </b>
            DeFi platforms operate on decentralized networks, reducing the need for centralized authorities and enabling greater autonomy for users.
          </li>
          <li>
            <b>Interoperability: </b>
            Many DeFi protocols are interoperable, meaning they can interact with each other seamlessly, allowing for the creation of complex financial products and services.
          </li>
          <li>
            <b>Transparency: </b>
            Transactions on the blockchain are transparent and can be audited by anyone, enhancing trust and accountability within the system.
          </li>
          <li>
            <b>Accessibility: </b>
            DeFi strives to provide financial services to anyone with an internet connection, including those who are underserved or excluded by traditional financial institutions.
          </li>
          <li>
            <b>Permissionless: </b>
            Users can access DeFi services without needing approval from intermediaries, reducing barriers to entry and enabling greater financial inclusion.
          </li>
        </ul>
        <br />
        Some common examples of DeFi applications include decentralized exchanges (DEXs), lending protocols, yield farming platforms, and stablecoins. However, the DeFi space is rapidly evolving, with new protocols and innovations emerging regularly. If you have a unique idea for a DeFi product, <a href="mailto:hello@rumblefish.dev">contact our team</a> to make it a reality!
      `,
      gradientOnFocus: theme.mixins.magentaGradient?.background as string,
    },

    {
      title: 'Q: What is a decentralized exchange (DEX)?',
      description: `A: A decentralized exchange (DEX) is a type of cryptocurrency exchange that operates without a central authority or intermediary. Unlike traditional centralized exchanges (CEXs), which rely on a centralized company to facilitate trading and custody of funds, DEXs use decentralized protocols and smart contracts to enable peer-to-peer trading directly between users.`,
      gradientOnFocus: theme.mixins.redGradient?.background as string,
    },
    {
      title: 'Q: Why hire Rumble Fish for defi product development?',
      description: `A:
        Hiring Rumble Fish for defi product development offers numerous benefits that can greatly enhance your project's success:
        <br />
        <ul>
          <li>
            <b>Expertise: </b>
            Rumble Fish boasts a team of highly skilled professionals with extensive experience in blockchain products development. Our expertise spans a wide range of technologies, ensuring that we can tackle projects of varying complexity with confidence.
          </li>
          <li>
            <b>Custom Solutions: </b>
            We understand that every project is unique, and we tailor our solutions to meet your specific needs. Whether you require a simple tool or a complex defi platform, we have the expertise to deliver a custom solution that aligns with your goals.
          </li>
          <li>
            <b>Focus on User Experience: </b>
            At Rumble Fish, we prioritize user experience in all our projects. We design intuitive interfaces and seamless navigation to ensure that your users have a positive experience when interacting with your defi product.
          </li>
          <li>
            <b>Quality Assurance: </b>
            Quality is at the forefront of everything we do. We employ rigorous testing processes to identify and address any issues before your product goes live, ensuring that it performs flawlessly and meets your expectations.
          </li>
          <li>
            <b>Timely Delivery: </b>
            We understand the importance of meeting deadlines and we work diligently to deliver projects on time and within budget. Our efficient project management ensures that your defi solution is completed according to schedule.
          </li>
          <li>
            <b>Ongoing Support: </b>
            Our relationship with clients doesn't end once the project is complete. We offer ongoing support and maintenance services to ensure that your defi product continues to perform optimally long after it's launched.
          </li>
        </ul>
      `,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },
  ];
};
